const ls = require('local-storage'); // tslint:disable-line
import GLOBAL from '../util/global';

let FORMER_HIJACK_FLAG: boolean = false;
// 修改cat配置，防止其对prajna打点
function hijackOwlConfig() {
    // 灵犀上报接口
    let ajaxIgnoreList = GLOBAL.__lxHosts;

    // prajna上报接口
    ajaxIgnoreList = ajaxIgnoreList.concat(GLOBAL.__prajnaHosts);

    const hackedConfig = {
        config: {
            resourceReg: "(.51ping|.dianping|.dpfile|.meituan|.sankuai|.maoyao|.kuxun|.maoyan|.neixin)",
            disableCache: false,
            resource: {
                delay: 1000,
                sampleApi: 1,
                combo: false,
                sample: 1,
            },
            name: "owl",
            invalid: {
                ajax: true,
            },
            ignoreList: {
                resource: ["https?://hls.dianping.com/", "https?://frep.meituan.net/"],
                js: ["Illegal invocation"],
                ajax: ajaxIgnoreList,
            },
            page: {
                auto: true,
                sample: 1,
            },
            ajax: {
                flag: true,
                duration: 3000,
            },
            error: {
                delay: 1000,
                combo: true,
                sample: 1,
            },
            metric: {
                sample: 1,
                combo: false,
                delay: 1500,
            },
            version: "1.5.15",
            timeout: {
                image: 3000,
                flag: false,
                ajax: 3000,
            },
        },
        ts: +new Date(), // 不要改
        md5: "3449c9e5e332f1dbb81505cd739fbf3f",
        delay: 604800000,
    };
    ls.set('owl_config', hackedConfig);
}

function hijackMiddleware(ctx: any, next: any): any {
    if (FORMER_HIJACK_FLAG) {
        FORMER_HIJACK_FLAG = false;
        if (GLOBAL.__lxHosts || GLOBAL.__catHosts) {
            hijackOwlConfig();
        }
    }
    next();
}

export default hijackMiddleware;



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./node_modules/tslint-loader??ref--1!./src/middleware/hijack-middleware.ts